.link {
    white-space: nowrap;
}